import React from 'react';
import FaTransactions from '../../FaTransactions';
import Heading from '@hubins/components/Heading';
import __ from 'localisation';

const OrdersFaTransactions = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>{__('fa_transactions')}</Heading>
      <FaTransactions />
    </>
  );
};

export default OrdersFaTransactions;
